import React from 'react'
import styled from 'styled-components'
import { func } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import CodigoPix from '../../../../components/CodigoPix/CodigoPix'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'
import { isArray } from '../../../../utils/helpers/helpers'
import {
  BOTAO_FECHAR,
  DESCRICAO_PAGUE_PIX,
  ERRO_GERAR_PIX,
  TITULO_ERRO_COMPRA,
  TITULO_SUCESSO_PIX
} from '../../constantsCardOpcionais'
import iconError from '../../../../assets/imagens/icon-error.svg'

const WrapperConclusaoPix = styled.div`
  position: relative;
  text-align: center;

  h3 {
    color: ${StyleGuide.cores.azul};
    margin-bottom: 20px;
    text-align: center;
  }

  p {
    text-align: center;
  }

  .conclusao-mensagem {
    font-size: 15px;
    line-height: 1.25;
    margin: 15px 0 40px;
  }

  .conclusao-pix {
    margin-top: 20px;
    text-align: center;
  }

  .conclusao-botao {
    margin-top: 16px;

    button {
      width: 100%;
    }
  }

  &.conclusao-erro h3 {
    color: ${StyleGuide.cores.vermelhoErro};

    &:before {
      background-image: url( ${iconError} );
      background-position: center;
      background-size: cover;
      content: '';
      display: block;
      margin: 0 auto 10px;
      height: 40px;
      width: 40px;
    }
  }

  .conclusao-fechar-modal {
    cursor: pointer;
    position: absolute;
    width: 30px;
    height: 30px;
    right: 5px;
    top: -5px;

    &:after,
    &:before {
      content: '';
      background-color: ${StyleGuide.cores.cinza500};
      display: block;
      position: absolute;
    }

    &:after {
      height: 2px;
      right: -9px;
      top: 9px;
      transform: rotate(45deg);
      width: 20px;
    }

    &:before {
      height: 20px;
      transform: rotate(45deg);
      right: 0;
      width: 2px;
    }
  }
`

const OpcionaisConclusaoPix = ( { fecharModal } ) => {
  const { respostaCompraOpcionais } = useOpcionais()

  const respostas = isArray( respostaCompraOpcionais ) ? respostaCompraOpcionais : []
  const respostaComPix = respostas.find( resposta => {
    return !resposta.erro && resposta.pix && resposta.pix.dados
  } )

  if ( !respostaComPix ) {
    return (
      <WrapperConclusaoPix className="conclusao-erro">
        <h3>{ TITULO_ERRO_COMPRA }</h3>

        <p className="conclusao-mensagem">{ ERRO_GERAR_PIX }</p>

        <Button
          invertido
          onClick={ () => fecharModal() }
          tema={ Button.BOTAO_PRETO }
        >
          { BOTAO_FECHAR }
        </Button>
      </WrapperConclusaoPix>
    )
  }

  return (
    <WrapperConclusaoPix>
      <h3>{TITULO_SUCESSO_PIX}</h3>

      <p>{DESCRICAO_PAGUE_PIX}</p>

      <div className="conclusao-pix">
        <CodigoPix
          codigoPix={ respostaComPix.pix.dados }
          urlQrCode={ respostaComPix.pix.url }
        />
      </div>

      <div className="conclusao-botao">
        <Button
          invertido
          onClick={ () => fecharModal() }
          tema={ Button.BOTAO_CURADORIA }
        >
          { BOTAO_FECHAR }
        </Button>
      </div>

      <div
        className="conclusao-fechar-modal"
        onClick={ () => fecharModal() }
      />
    </WrapperConclusaoPix>
  )
}

OpcionaisConclusaoPix.propTypes = {
  'fecharModal': func.isRequired
}

export default OpcionaisConclusaoPix
